import { randomStr } from '../../Shared';
import { generateThemeToken, getDefaultZoomUI } from '../../ThemeProvider';
import { getThemeToken } from './theme';
export const tooltipClasses = {
    popper: `ui-tooltip-popper-${randomStr()}`,
    tooltip: `ui-tooltip-${randomStr()}`,
    arrow: 'ui-tooltip-arrow',
};
export default function getStyle(theme, opts) {
    const themeToken = getThemeToken(theme.zoomUI || getDefaultZoomUI());
    const [token, tk] = generateThemeToken({
        componentName: 'Tooltip',
        theme,
        themeToken,
    });
    const { maxWidth, mode, width } = opts;
    // Overwrite the mode when the theme and mode are different
    const needToOverwriteMode = typeof mode !== 'undefined' && mode !== theme?.palette?.mode;
    const computedToken = needToOverwriteMode ? themeToken[mode] : token;
    const style = {
        [`& .${tooltipClasses.tooltip}`]: {
            fontFamily: tk(computedToken.fontFamily),
            backgroundColor: tk(computedToken.backgroundColor),
            color: tk(computedToken.textColor),
            padding: '3px 6px',
            fontSize: tk(computedToken.fontSize),
            lineHeight: tk(computedToken.lineHeight),
            fontWeight: tk(computedToken.fontWeight),
            borderRadius: '4px',
            border: `0.5px solid ${tk(computedToken.borderColor)}`,
            boxShadow: tk(computedToken.boxShadow),
            width: width ? `${width}px` : 'auto',
            maxWidth: maxWidth ? `${maxWidth}px` : '240px',
        },
        [`& .${tooltipClasses.arrow}`]: {
            color: tk(computedToken.backgroundColor),
            '&::before': {
                border: `1px solid ${tk(computedToken.borderColor)}`,
            },
        },
        [`&.${tooltipClasses.popper}`]: {
            zIndex: tk(computedToken.zIndex),
            '&[data-popper-placement="top"], &[data-popper-placement*="top"]': {
                [`.${tooltipClasses.tooltip}`]: {
                    marginBottom: '4px',
                },
            },
            '&[data-popper-placement="bottom"], &[data-popper-placement*="bottom"]': {
                [`.${tooltipClasses.tooltip}`]: {
                    marginTop: '4px',
                },
            },
            '&[data-popper-placement="left"], &[data-popper-placement*="left"]': {
                [`.${tooltipClasses.tooltip}`]: {
                    marginInlineEnd: '4px',
                },
            },
            '&[data-popper-placement="right"], &[data-popper-placement*="right"]': {
                [`.${tooltipClasses.tooltip}`]: {
                    marginInlineStart: '4px',
                },
            },
        },
    };
    return style;
}
